import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Cluster } from './cluster.interface';
import { ClusterService } from './cluster.service';
import defaultFilter, { DefaultFilterState } from './default-filters/default-filter.store';
import targetGroupFilter, { TargetGroupFilterState } from './target-group-filters/target-group-filter.store';

const service = new ClusterService();

export interface ClusterState {
   clustersOverview?: ApiResource<Array<Cluster>>;

   defaultFilter?: DefaultFilterState;
   targetGroupFilter?: TargetGroupFilterState;
}

const ClusterStore: Module<ClusterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_CLUSTERS_OVERVIEW(state, clustersOverview) {
         state.clustersOverview = clustersOverview;
      },
   },
   actions: {
      async getClusters(context, search: string) {
         const response = await service.getClusters(search);
         context.commit('SET_CLUSTERS_OVERVIEW', response);
         return response;
      },
   },
   modules: {
      defaultFilter,
      targetGroupFilter,
   },
};

export default ClusterStore;
